import { Link } from 'react-router';

import { useDefinitions, useInstances } from '@/api';
import { Badge, PageHeader, ProtocolBadge, Spinner } from '@/components/ui';
import { unitLabel } from '@/lib/format';

export function Definitions() {
	const defs = useDefinitions();
	const instances = useInstances();
	if (!defs.data) return <Spinner />;
	const categories = [...new Set(defs.data.map((d) => d.category))];
	const count = (id: string) => instances.data?.filter((i) => i.definitionId === id).length ?? 0;
	return (
		<>
			<PageHeader title="Catalogue" subtitle="Sensor definitions are built into the server. Create any number of sensors from each." />
			{categories.map((cat) => (
				<section key={cat} className="mb-6">
					<h2 className="mb-2 text-xs font-semibold tracking-wide text-fg-muted uppercase">{cat}</h2>
					<div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
						{defs.data
							.filter((d) => d.category === cat)
							.map((d) => (
								<Link key={d.id} to={`/definitions/${d.id}`} className="group flex flex-col gap-2 rounded-lg border border-border bg-surface p-4 transition hover:border-accent">
									<div className="flex items-start justify-between gap-2">
										<h3 className="font-medium group-hover:text-accent">{d.name}</h3>
										<ProtocolBadge protocol={d.expectedProtocol} />
									</div>
									<p className="line-clamp-2 text-sm text-fg-muted">{d.description}</p>
									<div className="mt-auto flex flex-wrap gap-1 pt-1">
										{d.fields.map((f) => (
											<Badge key={f.key}>
												{f.label}
												{f.unit && ` · ${unitLabel(f.unit)}`}
											</Badge>
										))}
									</div>
									<span className="text-xs text-fg-muted">
										<code className="font-mono">{d.id}</code> · {count(d.id)} sensor{count(d.id) === 1 ? '' : 's'}
									</span>
								</Link>
							))}
					</div>
				</section>
			))}
		</>
	);
}
